// extracted by mini-css-extract-plugin
module.exports = {"SingleSelectButton":"SelectAllButton_SingleSelectButton__vR5oY","CompositeButtonElement":"SelectAllButton_CompositeButtonElement__1AuS7"};